const editorSettings = {
    "calendarActive": false,
    "folderActive": true,
    "archiveActive": false,
    "filterActive": true,
    "exportActive": true,
    "folderCalendarSwap": true,
};

export default editorSettings;